import { Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Select } from '../../models/select';
import { FertilizersService } from '../../services/fertilizers.service';

@Component({
  selector: 'app-fertilizer-finder',
  templateUrl: './fertilizer-finder.component.html',
  styleUrls: ['./fertilizer-finder.component.css']
})
export class FertilizerFinderComponent implements OnInit {
  @Output() fertilizerSelection = new EventEmitter();
  @Input() required = false;
  @Input() fertilizerId?: number;
  @Input() fertilizerName?: number;

  fertilizers: any[];
  selected = false;
  textAutocomplete = {} as Select;

  constructor(private fertilizersService: FertilizersService) { }

  ngOnInit(): void {
    if (this.fertilizerId !== undefined && this.fertilizerName !== undefined) {
      this.selected = true;
      this.textAutocomplete = new Select(this.fertilizerId, this.fertilizerName);
    }
  }

  searchFertilizer(event) {
    this.fertilizerSelection.emit(undefined);
    this.selected = false;
    this.fertilizersService.search(event.query).subscribe(data => {
      this.fertilizers = data;
    });
  }

  selectFertilizer(event) {
    this.selected = true;
    this.fertilizerSelection.emit(event);
  }

  clearFertilizer(event) {
    this.selected = false;
    this.fertilizerSelection.emit(undefined);
  }
}